import type { GateDef } from '../track';

/**
 * Start/finish on segment `startSeg` at `startT`, then `count` checkpoints
 * spread evenly round the lap by distance (map units, so it doesn't depend
 * on scale). `avoid` lists segments a shortcut skips: no gate goes there.
 */
export function autoGates(
  centerline: [number, number][],
  startSeg: number,
  startT: number,
  count: number,
  avoid: number[] = [],
): GateDef[] {
  const n = centerline.length;
  const lens: number[] = [];
  const s0: number[] = [];
  let total = 0;
  for (let i = 0; i < n; i++) {
    const [ax, ay] = centerline[i];
    const [bx, by] = centerline[(i + 1) % n];
    s0.push(total);
    const l = Math.sqrt((bx - ax) * (bx - ax) + (by - ay) * (by - ay));
    lens.push(l);
    total += l;
  }
  const gates: GateDef[] = [{ seg: startSeg, t: startT }];
  const start = s0[startSeg] + lens[startSeg] * startT;
  for (let k = 1; k <= count; k++) {
    let s = (start + (total * k) / (count + 1)) % total;
    // Walk forward to a segment we're allowed to use, mid-segment-ish.
    for (let guard = 0; guard < n; guard++) {
      let seg = 0;
      while (seg < n - 1 && s0[seg + 1] <= s) seg++;
      if (!avoid.includes(seg) && lens[seg] > 1.5) {
        const t = Math.min(0.8, Math.max(0.2, (s - s0[seg]) / lens[seg]));
        gates.push({ seg, t });
        break;
      }
      s = (s0[(seg + 1) % n] + 0.01) % total;
    }
  }
  return gates;
}
